import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const Autocomplete = ({
    placeholder,
    icon,
    label,
    value = '',
    options = [],
    optionsPosition = 'bottom',
    debounceTime = 500,
    disabled = false,
    onChange = () => {}
}) => {
    const blipSelectRef = useRef(null);
    let time;

    useEffect(() => {
        const { current } = blipSelectRef;
        current.addEventListener('bdsSelectedChange', handleChange);

        return () => {
            current.removeEventListener('bdsSelectedChange', handleChange);
        };
        // eslint-disable-next-line
    }, []);

    const handleChange = (e) => {
        clearTimeout(time);
        time = setTimeout(() => onChange(e), debounceTime);
    };

    return (
        <bds-autocomplete
            ref={blipSelectRef}
            icon={icon}
            label={label}
            placeholder={placeholder}
            value={value}
            options-position={optionsPosition}
            disabled={disabled}
        >
            {!!options?.length &&
                options.map((option, index) => (
                    <bds-select-option
                        key={`${index}_${option.value}`}
                        value={option.value}
                    >
                        {option.label}
                    </bds-select-option>
                ))}
        </bds-autocomplete>
    );
};

Autocomplete.propTypes = {
    placeholder: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    options: PropTypes.array,
    optionsPosition: PropTypes.string,
    debounceTime: PropTypes.number,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
};

export default Autocomplete;
